import { z } from 'zod';

/// ////////////////////////////////////////
/// Enum
/// ////////////////////////////////////////

export const reportInvestmentFundCsvHeader = z.enum([
  'fundSheetNumber',
  'ministryName',
  'fundOwner',
  'projectName',
  'startYear',
  'endYear',
  'accumulatedInvestmentsFromTheGovernment',
  'investmentAmount2YearsBefore',
  'investmentAmount1YearBefore',
  'investmentAmountCurrentYear',
  'accumulatedInvestmentFromPrivateSectors',
  'businessForm',
  'investmentDecision2YearsBeforeCount',
  'investmentDecision2YearsBeforeAmount',
  'investmentExecution2YearsBeforeCount',
  'investmentExecution2YearsBeforeAmount',
  'investmentDecision1YearBeforeCount',
  'investmentDecision1YearBeforeAmount',
  'investmentExecution1YearBeforeCount',
  'investmentExecution1YearBeforeAmount',
  'investmentDecisionCurrentYearCount',
  'investmentDecisionCurrentYearAmount',
  'investmentExecutionCurrentYearCount',
  'investmentExecutionCurrentYearAmount',
  'overview',
]);

/// ////////////////////////////////////////
/// Model
/// ////////////////////////////////////////

export const ReportFundBusinessElementModel = z.object({
  businessForm: z.string(),
  investmentDecisionCount2YearsBefore: z.number().nullable(),
  investmentDecisionAmount2YearsBefore: z.number().nullable(),
  investmentExecutionCount2YearsBefore: z.number().nullable(),
  investmentExecutionAmount2YearsBefore: z.number().nullable(),
  investmentDecisionCount1YearBefore: z.number().nullable(),
  investmentDecisionAmount1YearBefore: z.number().nullable(),
  investmentExecutionCount1YearBefore: z.number().nullable(),
  investmentExecutionAmount1YearBefore: z.number().nullable(),
  investmentDecisionCountCurrentYear: z.number().nullable(),
  investmentDecisionAmountCurrentYear: z.number().nullable(),
  investmentExecutionCountCurrentYear: z.number().nullable(),
  investmentExecutionAmountCurrentYear: z.number().nullable(),
});

export const ReportFundInvestmentModel = z.object({
  fundSheetNumber: z.number(),
  ministryName: z.string(),
  fundSheetBranchNumber: z.number().nullable(),
  fundOwner: z.string().nullable(),
  projectName: z.string(),
  startYear: z.number().nullable(),
  endYear: z.number().nullable(),
  accumulatedInvestmentsFromTheGovernment: z.number().nullable(),
  negativeAccumulatedInvestmentsFromTheGovernmentCount: z.number().nullable(),
  accumulatedInvestmentsFromTheGovernmentAccountingTypeNames: z
    .string()
    .array(),
  investmentAmount2YearsBefore: z.number().nullable(),
  investmentAmount1YearBefore: z.number().nullable(),
  investmentAmountCurrentYear: z.number().nullable(),
  accumulatedInvestmentFromPrivateSectors: z.number().nullable(),
  fundBusinesses: ReportFundBusinessElementModel.array(),
  overview: z.string().nullable(),
});
export const ReportInvestmentFundsModel = z.object({
  data: ReportFundInvestmentModel.array(),
  organizations: z.object({ id: z.string().uuid(), name: z.string() }).array(),
});
export const ReportInvestmentFundsParamsModel = z.object({
  isAllOrganization: z.boolean().nullish(),
  fiscalYear: z.any().transform((v) => Number(v)),
});

/// ////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////

export const ReportInvestmentFundsFilterSchema = z.object({
  fiscalYear: z.any().transform((v) => Number(v)),
  organizationIds: z
    .union([z.literal('all'), z.string().uuid()])
    .array()
    .min(1),
});
